export default function version() {
	console.log("Madnes version: 22.0.12");
	console.log("Madnes commit: 2273de34");
	console.log("JB version: 1.2.0");
	console.log("JB commit: bdbf796")
	console.log("Game version: 26.44.01-beta-378605");
	console.log("Build date: Mon Nov  2 11:37:37 UTC 2026");
	console.log("Git commit: 7de9ae6b");
	console.log("Git commit date: 2026-11-02T11:23:20+01:00");
}